export enum RequestNoteTypes {
    Requester = 0,
    ApproverToRequester,
    ApproverToFinalApprover,
    FinalApproverToApprover
}
